import { memo } from 'react';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { IconShare02 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import LikeBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/LikeBtn';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  type?: 'heart' | 'share';
  active?: boolean;
  onClick?: () => Promise<void>;
}

function EvtShareBtn({ type = 'heart', active = false, onClick }: IProps) {
  const cName = classNameBind(['share-btn', type]);
  return (
    <S.EvtShareBtn className={cName}>
      {type === 'heart' ? (
        <LikeBtn active={active} onClick={onClick} />
      ) : (
        <Button onClick={onClick} className="evt-btn-share">
          <IconShare02 />
        </Button>
      )}
    </S.EvtShareBtn>
  );
}

export default memo(EvtShareBtn);
